import styled from 'styled-components'

export const TabWrapper = styled.div`
  background-color: white;
  padding: 0;
  border: 3px solid #5C81B9;
  max-width: 1250px;
  border-radius: 6px;
`
